import { c as _c } from "react/compiler-runtime";
import { cn } from '@ncai-axe/react-ui-v3/utils';
import styles from './styles.module.scss';
type RightPanelProps = {
  children: React.ReactNode;
  className?: string;
};
export const RightPanel = t0 => {
  const $ = _c(5);
  const {
    className,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn(styles.panel, styles.right, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
type LeftPanelProps = {
  children: React.ReactNode;
  className?: string;
};
export const LeftPanel = t0 => {
  const $ = _c(5);
  const {
    className,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn(styles.panel, styles.left, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
type PanelTitleProps = {
  label: string;
};
export const PanelTitle = t0 => {
  const $ = _c(2);
  const {
    label
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <h4 className={styles.panelTitle}>{label}</h4>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};